import { combineEpics } from 'redux-observable';
import { fetchInsurance$ } from 'modules/insurance/epics/fetchInsurance$';

export default combineEpics(fetchInsurance$);
